/*eslint-disable */
let $ = window.jQuery = require('jquery');

import {
  mapGetters,
  mapState
} from 'vuex';

import SearchBar from '../header-searchbar/index';
import {bus} from '@/main';

export default {
  name: 'header-after-login',
  components: {
    'search-bar': SearchBar
  },
  props: [],
  data() {
    return {
      firstname: '',
      lastname: '',
      email: '',
      avatar: '',
      filterinput: '',
      profileInfoData: '',
      showHomeMenu: true,
      showQuizMenu: true,
      myProfileMenu: false,
      isOpen :false,
      searchList:''
    }
  },
  computed: {
    ...mapGetters([
      'getProfileInfo'
    ]),
    ...mapState([
      'profileInfo'
    ]),
    getUserInfo() {
      if (this.$store.getters.isAuthenticated == true) {
        this.$store.dispatch('getProfile').then((res) => {
          this.firstname= this.$store.getters.getProfileInfo.first_name;
          this.lastname = this.$store.getters.getProfileInfo.last_name;
          this.email = this.$store.getters.getProfileInfo.email;
          this.avatar = this.$store.getters.getProfileInfo.profile.avatar;
          $('.app-loader').hide()
          $('.routeloader').hide()
        })
      }
    }
  },
  mounted() {
    bus.$on('showHomeMenuBtn', (data) => {
      this.showHomeMenu = data;
    });
    bus.$on('showQuizMenubtn', (data) => {
      this.showQuizMenu = data;
    });
    bus.$on('showMyProfileMenu', (data) => {
      this.myProfileMenu = data;
    });
    bus.$on('ShowSearchKeyWord', (data) => {
      this.filterinput = data;
    });
    header: this.$store.dispatch('getAuthHeader');
    // this.$store.dispatch('inspectAccessToken');
    this.getUserInfo;
  },
  methods: {
    movingSlideMethod(){
      bus.$emit('movingSlideStateBus', 3);
    },
    handleScroll() {
      let header = document.querySelector(".header_fix");
      if (window.scrollY > 30 && !header.className.includes('darkBg')) {
        header.classList.add('darkBg');
      } else if (window.scrollY < 30) {
        header.classList.remove('darkBg');
      }
    },
    getImgUrl(pic) {
      if (pic == '' || !pic || pic == 'undefined') {
        return require('../../../../assets/images/user_default.png')
      } else {
        return pic
      }
    },
    logOutUser() {
      if ('BroadcastChannel' in self) {
        authChannel.postMessage({
          cmd: 'logout'
        })
      }
    },
    logout: function() {
      this.$store.dispatch('logout')
        .then(() => {
          this.logOutUser()
          this.$router.push('/login')
        })
    },
    logoClick: function() {
      $('body').removeClass('show');
      $('.mobilemenu-icon').removeClass('open');
      this.$router.push('/');
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  beforeMount() {
    this.getUserInfo;
  },
  watch: {
    getUserInfo(){
      this.firstname= this.$store.getters.getProfileInfo.first_name;
      this.lastname = this.$store.getters.getProfileInfo.last_name;
      this.email = this.$store.getters.getProfileInfo.email;
      this.avatar = this.$store.getters.getProfileInfo.profile.avatar;
      return;
    },
  }
}